import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.send-web-socket-to-user';
import * as api from '../../../clients/api';

@Injectable()
export class ApiSendWebSocketToUserEffects {

    SendWebSocketToUser$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_SEND_WEB_SOCKET_TO_USER),
        mergeMap((x: ac.PostSendWebSocketToUserAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postSendWebSocketToUser(x.webSocketMessageRequest).pipe(
                map((result: any) => {
                    return new ac.PostSendWebSocketToUserErfolgreichAction(x.webSocketMessageRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostSendWebSocketToUserFehlerAction(error, x.webSocketMessageRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AccountService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AccountService {
        if (this.service === null) {
            this.service = this.injector.get(api.AccountService);
        }
        return this.service;
    }
}
